import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

const SCROLL_LOCK_CLASS = 'astral-dialog-scroll-locked';

/** Coordinates page scroll locking across one or more simultaneously open dialogs. */
@Injectable({ providedIn: 'root' })
export class AstralDialogScrollLockService {
  private activeLocks = 0;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  acquire(): void {
    this.activeLocks += 1;
    if (this.activeLocks === 1) {
      this.document.documentElement.classList.add(SCROLL_LOCK_CLASS);
    }
  }

  release(): void {
    if (this.activeLocks === 0) {
      return;
    }

    this.activeLocks -= 1;
    if (this.activeLocks === 0) {
      this.document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
    }
  }
}
